import React from 'react';
import { Dialog, T } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import styles from './SuccessfulPurchaseDialog.module.scss';
export function SuccessfulPurchaseDialog({ open, onClose, imageUrl, itemTitle, onUseItem }) {
    const handleConfirm = ()=>{
        onUseItem();
        onClose();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "md"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(Dialog.ImageTitle, {
        image: {
            src: imageUrl,
            alt: emptyTranslation
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:storePage.success.purchaseSuccess'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.line
    }, /*#__PURE__*/ React.createElement(T, {
        id: itemTitle
    })), /*#__PURE__*/ React.createElement("p", {
        className: styles.line
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:storePage.success.findInProfile'
        }
    })))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: handleConfirm
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:storePage.success.useItNow'
        }
    }))));
}
